// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlight{background:#ff7}`, "",{"version":3,"sources":["<input css 10>"],"names":[],"mappings":"AAAA,WAAW,eAAe","sourcesContent":[".highlight{background:#ff7}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
